/**
 * VERSIONE LIBRERIA 3
 *
 * estende il core controller con le azioni di default di tutta la libreria
 */
var Controller = CoreController.extend({
    jobId : null,
    listKey : null,
    errorListKey : null,
    serachKey : null,
    csvLoaded : false,
    csvSaved : false,
    loadcsvMessage : 'Validazione e precaricamento dei dati del csv',
    savecsvMessage : 'Salvataggio di dati caricati',
    uploadForm : null,
    dataForm : null,
    hasErrors : false,
    errors : [],
    iszip : false,
    mainViewKey : null,

    /**
    *
    * ---------------------------
    * azioni connesse con le varie view attraverso la ricerca di tutti i controlli che hanno
    * l'attributo data-action
    * ----------------------------
    *
    **/
    _reset : function () {
        var self = this;
        self.csvLoaded = false;
        self.csvSaved = false;
        //TODO refresh controlli form

    },
    actionAddCsv: function (key) {
        var self = this;
        log.debug('addCsv',key);
        /*
         * risposta in load
         * durante la load
         * {
         *  rows : [] , //righe caricates
         *  current_row : 0,
         *  errors : [{
         *      row : int,
         *      col : int,
         *      errors : [
         *          {key : descrizione},
         *      ]
         *  }]
         */
        var vConf = self._viewConfig[key];
        var view = self.getView(key);
        if (!view.fileName) {
            $.errorDialog('Devi prima caricare un file dati');
            return ;
        }
        var postData = view.getFormData();
        $.confirmDialog('Questa operazione potrebbe richiedere minuti, continuare?').ok(function () {
            $.waitStart();
            if (self.listKey) {
                delete self.listKey;
            }
            if (self.errorListKey)
                delete self.errorListKey;
            var confRequest = {
                url : Routes.getUrlInstance('addcsv',{}),
                query_params : vConf.query_params?vConf.query_params:{},
                method : Routes.addcsv.method,
                post_params : postData
            };
            self._executeRequest(confRequest,function (json) {
                $.waitEnd();
                if (json.error) {
                    $.errorDialog(json.msg);
                    return ;
                }
                self.getView(key).showProgress(self.loadcsvMessage);
                //$.progressDialog(self.loadcsvMessage);
                self.jobId = json.jobId;
                view.setLoadId(json.jobId);
                //self.dataForm.find('input[name="csv_load_id"]').val(json.jobId);
                $.waitStart();
                self.statusCsv(key);
            });
        });

        return ;

    },
    statusCsv : function (key) {
        var self = this;
        var vConf = self._viewConfig[key];
        var confRequest = {
            url : Routes.getUrlInstance('statuscsv',{jobId:self.jobId}),
            query_params : vConf.query_params?vConf.query_params:{},
            method : Routes['statuscsv'].method,
            post_params : {}
        }
        self._executeRequest(confRequest,function (json) {

            if (json.error) {
                $.waitEnd();
                $.errorDialog(json.msg);
                return ;
            }
            if (json.job.end) {
                self.getView(key).hideProgress();
                $.waitEnd();
                //$.progressDialogClose();
                if (parseInt(json.job.error) ) {
                    $.errorDialog(json.job.msg);
                    return ;
                }
                self.getView(key).goToNextPhase();
                //self.getView(key).currentPhase = self.getView(key).phases[2];

                self.csvLoaded = true;
                self.jobId = 0;
                //$(self.options.container).find('[data-action="savecsv"]').prop("disabled",false);
                $.messageDialog("Precaricamento effettuato");
                self.renderView(key);
                self.actionCsvShowAll(key);
                return ;
            }
            if (json.job.progress) {
                self.getView(key).showProgress(self.loadcsvMessage, json.job.progress);
                //$.progressDialog(self.loadcsvMessage, json.job.progress);
            } else {
                self.getView(key).showProgress(self.loadcsvMessage);
                //$.progressDialog(self.loadcsvMessage);
            }
            setTimeout(function () {
                self.statusCsv(key);
            },3000);
        });


        return ;
    },
    actionCsvCancel : function () {
        window.location.reload();
    },
    actionCsvShowAll : function (key) {
        var self = this;
        var vConf = self._viewConfig[self.mainViewKey];
        self._createSearchForm();
        if (!self.listKey) {
            var listConf = Facade.getConf().getConf(vConf.view.modelName,'csvdata'); // new ListConfs();
            listConf.container = $(vConf.view.config.container).find('[data-csvfiledata]');
            listConf.pagination = true;
            var data = {
                value : null,
                translations : null
            };

            self.listKey = controller.addView('ViewCsvData',{
                config : listConf,
                //container : "#viewList",
                modelName : vConf.view.modelName,
                routeParams : {
                    model : vConf.view.modelName,
                    jobId : vConf.view.loadId
                },
                routeType : 'datacsv'
            });
        }

        self.renderView(self.listKey);
        return ;
    },
    actionCsvShowError : function (key) {
        var self = this;
        var vConf = self._viewConfig[self.mainViewKey];
        if (!self.errorListKey) {
            var listConf = Facade.getConf().getConf(vConf.view.modelName,'csvdata'); // new ListConfs();
            listConf.container = $(vConf.view.config.container).find('[data-csvfiledata]');
            listConf.pagination = true;
            var data = {
                value : null,
                translations : null
            };

            self.errorListKey = controller.addView('ViewCsvData',{
                config : listConf,
                //container : "#viewList",
                modelName : vConf.view.modelName,
                routeParams : {
                    model : vConf.view.modelName,
                    jobId : vConf.view.loadId
                },
                routeType : 'errorcsv'
            });
        }

        self.renderView(self.errorListKey);
        return ;
    },
    actionCsvRevalidate : function(key) {
        var self = this;
        $.waitStart();
        var vConf = self._viewConfig[self.mainViewKey];
        var model = vConf.view.modelName;
        var jobId = self.jobId;
        var confRequest = {
            url : Routes.getUrlInstance('csvrevalidate',{model:model,jobId:vConf.view.loadId}),
            query_params : {},
            method : Routes.csvrevalidate.method,
            post_params : {}
        };
        self._executeRequest(confRequest,function (json) {
            $.waitEnd();
            //if (callback) {
            //    return callback(json);
            //}
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            self.actionCsvShowAll(key);
        });
    },
    actionSaveCsv: function (key) {
        var self = this;
        log.debug("saveCsv",key);

        var vConf = self._viewConfig[key];
        var view = self.getView(key);
        if (!self.csvLoaded) {
            $.errorDialog("Prima di salvarli, devi precaricare i dati");
            return ;
        }
        var postData = view.getFormData();

        $.confirmDialog("Questa operazione potrebbe richiedere minuti, continuare?").ok(function () {
            $.waitStart();
            var confRequest = {
                url : Routes.getUrlInstance('savecsv',{}),
                query_params : vConf.query_params?vConf.query_params:{},
                method : Routes['savecsv'].method,
                post_params : postData
            }
            self._executeRequest(confRequest,function (json) {
                $.waitEnd();
                if (json.error) {
                    $.errorDialog(json.msg);
                    return ;
                }
                //$.progressDialog(self.savecsvMessage);
                self.getView(key).showProgress(self.savecsvMessage);
                self.jobId = json.jobId;
                //view.setJobId(json.jobId);
                //self.dataForm.find('input[name="csv_load_id"]').val(json.jobId);
                self.saveCsvStatus(key)
            });
        })
    },

    saveCsvStatus : function (key) {

        var self = this;
        if (!self.jobId) {
            $.errorDialog("Nessun job di salvataggio presente");
            return ;
        }

        var vConf = self._viewConfig[key];
        var confRequest = {
            url : Routes.getUrlInstance('statuscsv',{jobId:self.jobId}),
            query_params : vConf.query_params?vConf.query_params:{},
            method : Routes['statuscsv'].method,
            post_params : {}
        }
        self._executeRequest(confRequest,function (json) {
            $.waitEnd();
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            if (json.job.end) {
                self.getView(key).hideProgress();
                //$.progressDialogClose();
                if (parseInt(json.job.error) ) {
                    $.errorDialog(json.job.msg);
                    return ;
                }
                $.messageDialog("Salvataggio effettuato").ok(function () {
                    $.waitStart();
                    document.location.reload();
                })
                self.csvSaved = true;
                self.jobId = 0;
                return ;
            }
            if (json.job.progress) {
                //$.progressDialog(self.savecsvMessage, json.job.progress);
                self.getView(key).showProgress(self.savecsvMessage, json.job.progress);
            } else {
                //$.progressDialog(self.savecsvMessage);
                self.getView(key).showProgress(self.savecsvMessage);
            }
            setTimeout(function () {
                self.saveCsvStatus(key);
            },3000);
        });
        return;
    },
    actionRecuperaCsv : function (key) {
        var self = this;
        var vConf = self._viewConfig[key];
        var confRequest = {
            url : Routes.getUrlInstance('recuperacsv',{model:vConf.view.modelName}),
            query_params : {},
            method : Routes['recuperacsv'].method,
            post_params : {}
        }
        self._executeRequest(confRequest,function (json) {
            $.waitEnd();
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            if (json.result.length > 0) {
                var html = $.getTemplate('#recorvery_items_tpl', json.result);
                $.generalDialog(html, {
                    title : 'Recupera csv caricati',
                    btok_label : 'Seleziona',
                    btcancel_label : 'Annulla',
                }).ok(function () {
                    if ($('#generalDialog').find('input[name="csv_id"]:checked').length > 0) {
                        var jobId = $('#generalDialog').find('input[name="csv_id"]:checked').val();
                        self.jobId = jobId;
                        vConf.view.setLoadId(jobId);
                        if (self.listKey) {
                            delete self.listKey;
                        }
                        if (self.errorListKey)
                            delete self.errorListKey;
                        self.actionCsvShowAll(key);
                        self.csvLoaded = true;
                        self.jobId = 0;

                        //alert('checked ' + $('#generalDialog').find('input[name="csv_id"]:checked').val());
                        //self.dataForm.find('input[name="csv_load_id"]').val(jobId).attr('value',jobId);

                        //$(self.options.container).find('[data-action="savecsv"]').prop("disabled",false);

                    }

                });
            } else {
                $.messageDialog('Nessun csv da recuperare');
            }
        });

    },
    fixCsvError : function (model,data,callback) {
        var self = this;
        $.waitStart();
        var confRequest = {
            url : Routes.getUrlInstance('csvrowupdate',{model:model}),
            query_params : {},
            method : Routes.csvrowupdate.method,
            post_params : data
        };
        self._executeRequest(confRequest,function (json) {
            $.waitEnd();
            if (callback) {
                return callback(json);
            }
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
        });
    },

    _createSearchForm : function () {
        var self = this;
        var vConf = self._viewConfig[self.mainViewKey];
        var searchConf = Facade.getConf().getConf(vConf.view.modelName,'search');
        // se esiste una search la istanzio
        if (Object.keys(searchConf.fields).length > 0) {
            if (!self.serachKey) {
                searchConf.container = $(vConf.view.config.container).find('[data-csvsearch]');
                var data = {
                    value : null,
                    translations : null
                };

                var viewClass ="ViewSearch";
                if (searchConf.groups) {
                    searchConf.templateId = '#default_view_search_group2_tpl';
                    viewClass ="ViewSearchG2";
                }
                self.serachKey = controller.addView(viewClass,{
                    config : searchConf,
                    //container : "#viewList",
                    modelName : vConf.view.modelName,
                    routeParams : {
                        model : vConf.view.modelName,
                    },
                    routeType : 'search'
                });
            }
            self.renderView(self.serachKey);
        }
    },
    /**
     * esegue il reload di una view e chiamata la callback se presente alla fine del caricamento
     * @param key : id key della view
     * @param callback : eventuali callback terminazione reload
     */
    reload : function (key,callback) {
        var self = this;
        self._viewConfig[key].view.data = null;
        $.waitStart();
        self.renderView(key, function () {
            $.waitEnd();
            if (callback) callback();
        });
    },
    nextPage: function (key) {
        var self = this;
        var view = self._viewConfig[key].view;
        
        if (view.data.pagination.current_page + 1 <= view.data.pagination.last_page) {
            $.waitStart();
            self._viewConfig[key].query_params.page = view.data.pagination.current_page + 1;
            self._viewConfig[key].query_params.paginateNumber = view.data.pagination.per_page;
            //self._viewConfig[key].query_params['paginateNumber'] = 10; //view.data.pagination.current_page + 1;
            view.data = null;
            self.renderView(key, function () {
                $.waitEnd();
            });
        }
    },

    prevPage: function (key) {
        var self = this;
        var view = self._viewConfig[key].view;
        if (view.data.pagination.current_page -1 > 0) {
            $.waitStart();
            self._viewConfig[key].query_params.page = view.data.pagination.current_page - 1;
            self._viewConfig[key].query_params.paginateNumber = view.data.pagination.per_page;
            //self._viewConfig[key].query_params['paginateNumber'] = 10; //view.data.pagination.current_page + 1;
            view.data = null;
            self.renderView(key, function () {
                $.waitEnd();
            });
        }
    },

    firstPage: function (key) {
        var self = this;
        var view = self._viewConfig[key].view;
        if (view.data.pagination.current_page > 1) {
            $.waitStart();
            //view.renderWait();
            self._viewConfig[key].query_params.page = 1;
            self._viewConfig[key].query_params.paginateNumber = view.data.pagination.per_page;
            //self._viewConfig[key].query_params['paginateNumber'] = 10; //view.data.pagination.current_page + 1;
            view.data = null;
            self.renderView(key, function () {
                $.waitEnd();
            });
        }
    },

    lastPage: function (key) {
        var self = this;
        var view = self._viewConfig[key].view;
        if (view.data.pagination.current_page < view.data.pagination.last_page) {
            $.waitStart();
            self._viewConfig[key].query_params.page = view.data.pagination.last_page;
            self._viewConfig[key].query_params.paginateNumber = view.data.pagination.per_page;
            //self._viewConfig[key].query_params['paginateNumber'] = 10; //view.data.pagination.current_page + 1;
            view.data = null;
            self.renderView(key, function () {
                $.waitEnd();
            });
        }
       
    },

    perPage : function (key,perPage) {
        var self = this;
        console.log("perpage",key,perPage);
        var view = self._viewConfig[key].view;
        $.waitStart();
        self._viewConfig[key].query_params.page = 1;
        self._viewConfig[key].query_params.paginateNumber = perPage;
        //self._viewConfig[key].query_params['paginateNumber'] = 10; //view.data.pagination.current_page + 1;
        view.data = null;
        self.renderView(key, function () {
            $.waitEnd();
        });

    },



    actionSave : function (key,pk,params,callback) {
        var self = this;
        var vConf = self._viewConfig[key];
        //vConf.post_params = {};
        vConf.post_params = {
            _method : vConf.post_params._method
        };
        var postData = vConf.view.getFormData();
        //log.info('formData', postData);
        $.waitStart();
        self._sendData(key,postData,function (json) {
            $.waitEnd();
            if (json.error && !callback) {
                $.errorDialog(json.msg);
                return ;
            }
            if (callback)
                return callback(json);

            $.messageDialog('Salvataggio avvenuto con successo').ok(function () {

                //vConf.view.successMsg(json.msg);
                //if (callback)
                //    callback(json);
                //else {
                    vConf.view.setData(null);
                    self.renderView(key);
                //}
            });
            
        });
    },

    actionSaveBack : function (key,pk,params,callback) {
        var self = this;
        var _cb = callback?callback:function (json) {
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            $.messageDialog('Salvataggio avvenuto con successo').ok(function () {
                window.history.back();
            });
        }
        self.actionSave(key,pk,params,_cb);
    },

    actionSearch: function (key) {
        var self = this;

        var view = self._viewConfig[key].view;
        var params = view.getParams();
        var connectedView = self._viewConfig[key].connected_view.search;
        if( !connectedView || connectedView.length === 0) {
            params.page = 1;
            window.location.href = window.location.origin + Facade.getUrl(window.location.pathname + '?' + $.param(params));
            return ;

            //document.location.href = Facade.getUrl("/list/" + view.modelName + "?"+ $.param(params));
            //return ;
        }
        for (var i in connectedView) {
            var connectionView = connectedView[i];
            var vConf = self._viewConfig[connectionView.key];
            vConf.view.renderWait();
            vConf.query_params = params; //_.extend(vConf.query_params,params);
            vConf.query_params.page = 1;

            vConf.view.setData(null);
            self.renderView(connectionView.key);
        }
    },
    /**
     * resetta tutti i valori dei campi che non sono operatori.
     * per ora usata solo nella search
     * @param key
     */
    actionReset: function (key) {
        var self = this;
        var vConf = self._viewConfig[key];
        //TODO operazione di reset per le select e check
        var itemNone = window.ItemNoneValue ? window.ItemNoneValue : '';
        $(vConf.view.config.container).find('input:not([data-control_operator])').attr('value','').prop('value','').val('');
        $(vConf.view.config.container).find('select').attr('value',itemNone).prop('value',itemNone).val(itemNone);
        self.actionSearch(key);
    },

    actionReload : function (key) {
        var self = this;
        self.reload(key);
        /*
        var vConf = self._viewConfig[key];
        //TODO operazione di reset per le select e check
        $(vConf.view.config.container).find('input:not([data-control_operator])').attr('value','').prop('value','').val('');
        self.actionSearch(key);
        */
    },
    actionEdit : function (key,pk) {
        var self = this;
        var view = self._viewConfig[key].view;
        var connectedView = self._viewConfig[key].connected_view.edit;
        if( !connectedView || connectedView.length === 0) {
            var constraintSuffix = '';
            if (view.config.constraint) {
                constraintSuffix = '/' + view.config.constraintKey + '/' + view.config.constraintValue;
            }
            document.location.href=Facade.getUrl('/edit/' + view.modelName + '/' + pk + constraintSuffix);
            return ;
        }

        for (var i in connectedView) {
            var connectionView = connectedView[i];
            var vConf = self._viewConfig[connectionView.key];
            vConf.view.renderWait();
            vConf.params.routeParams.pk = pk;
            vConf.post_params = {};
            vConf.view.routeType = 'edit';
            vConf.routeType = 'edit';

            /*
            if (vConf.params.routeParams.constraintKey) {
                vConf.view.routeType = 'editConstraint';
                vConf.routeType = 'editConstraint';
            } else {
                vConf.view.routeType = 'edit';
                vConf.routeType = 'edit';
            }
            */
            vConf.params.pk  = pk;
            vConf.view.setData(null);
            self.renderView(connectionView.key,function () {
                
            });
        }
    },

    actionDelete: function (key,pk) {
        var self = this;
        var viewConf = self._viewConfig[key];
        var view = viewConf.view;
        $.confirmDialog('Sei sicuro di voler cancellare l\'elemento?').ok(function () {
            
            var urlValues = {
                model:viewConf.params.modelName,
                pk : pk
            };
            var sConf = {
                url : Routes.getUrlInstance('remove',urlValues),
                query_params : {},
                method : Routes.remove.method,
                post_params : {'_method': 'DELETE'}
            };
            $.waitStart();
            self._executeRequest(sConf,function (json) {
                $.waitEnd();
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
                viewConf.view.renderWait();
                viewConf.view.setData(null);
                self.renderView(key);
            });
        });

    },

    /**
     * carica i dati e mostra la view insert 
     */
    actionInsert : function(key) {
        var self = this;
        log.debug("CoreController.insert called ",key);
        var view = self._viewConfig[key].view;
        var connectedView = self._viewConfig[key].connected_view['showInsert'];
        if( !connectedView || connectedView.length == 0) {
            var constraintSuffix = '';
            if (view.config.constraint) {
                constraintSuffix = '/' + view.config.constraintKey + '/' + view.config.constraintValue;
            }
            document.location.href=Facade.getUrl("/insert/" + view.modelName + constraintSuffix);
            return ;
        }
        for (var i in connectedView) {
            var connectionView = connectedView[i];
            self.insert(connectionView.key);
            /*
            var vConf = self._viewConfig[connectionView.key];
            vConf.view.routeType = 'insert';
            vConf.routeParams.pk = null;
            vConf.view.renderWait();
            vConf.params.pk  = null;
            vConf.view.setData(null);
            self.renderView(connectionView.key,function () {
                
            });
*/
        }
    },

    insert : function(key) {
        var self = this;
        var vConf = self._viewConfig[key];
       /* if (vConf.params.routeParams.constraintKey) {
            vConf.view.routeType = 'insertConstraint';
            vConf.routeType = 'insertConstraint';
        } else {
            vConf.view.routeType = 'insert';
            vConf.routeType = 'insert';
        }*/
        vConf.view.routeType = 'insert';
        vConf.routeType = 'insert';
        vConf.params.routeParams.pk = null;
        vConf.view.renderWait();
        vConf.params.pk  = null;
        vConf.view.setData(null);
        self.renderView(key,function () {
            
        });
        /*
        log.debug("CoreController.insert called ",key);
        var view = self._viewConfig[key].view;
        var connectedView = self._viewConfig[key].connected_view['insert'];
        if( connectedView.length == 0) {
            document.location.href="/insert/" + view.modelName;
            return ;
        }
        for (var i in connectedView) {
            var connectionView = connectedView[i];
            var vConf = self._viewConfig[connectionView.key];
            vConf.view.routeType = 'insert';
            vConf.routeParams.pk = null;
            vConf.view.renderWait();
            vConf.params.pk  = null;
            vConf.view.setData(null);
            self.renderView(connectionView.key,function () {
                
            });
        }
        */
    },


    actionView: function (key,pk) {
        var self = this;
        var view = self._viewConfig[key].view;
        var connectedView = self._viewConfig[key].connected_view['view'];
        if( !connectedView || connectedView.length == 0) {
            var constraintSuffix = '';
            if (view.config.constraint) {
                constraintSuffix = '/' + view.config.constraintKey + '/' + view.config.constraintValue;
            }
            document.location.href=Facade.getUrl("/view/" + view.modelName + "/" + pk + constraintSuffix);
            return ;
        }

        for (var i in connectedView) {
            var connectionView = connectedView[i];
            var vConf = self._viewConfig[connectionView.key];
            vConf.view.renderWait();
            vConf.routeType = 'view';
            vConf.view.routeType = 'view';
            vConf.params.routeParams.pk = pk;
            vConf.params.pk  = pk;
            vConf.view.setData(null);
            self.renderView(connectionView.key,function () {
                
            });
        }
    },
    set : function (key,pk,params) {
        var self = this;
        console.log('action set',key,pk,params);
        var viewConf = self._viewConfig[key];
        var urlValues = {
            model:viewConf.params.modelName,
            field : params.field,
            value : params.value
        };
        var urlType = viewConf.view.type;

        var sConf = {
            url : Routes.getUrlInstance('set',urlValues),
            query_params : {},
            method : Routes.set.method,
            post_params : {id : pk}
        };
        $.waitStart();
        self._executeRequest(sConf,function (json) {
            $.waitEnd();
            if (json.error) {
                $.errorDialog(json.msg);
                return;
            }
            viewConf.view.setData(null);
            self.renderView(key);
            // TODO fare il reload della view?
        });
    },

    order: function (key,pk) {
        var self = this;
        //console.log('key ' + key + " pk " + pk,self._viewConfig[key]);
        var vConf = self._viewConfig[key];

        var order_field = vConf.view.data.resultParams.order_field;
        var order_direction = vConf.view.data.resultParams.order_direction;
        if (order_field == pk) {
            order_direction = order_direction=='ASC'?'DESC':'ASC';
        } else {
            order_field = pk;
            order_direction = 'ASC';
        }
        vConf.query_params.order_field = order_field;
        vConf.query_params.order_direction = order_direction;

        vConf.view.renderWait();
            //vConf.params.pk  = pk;
        vConf.view.setData(null);
        self.renderView(key,function () {
                
        });
    },
    actionDeleteAll : function (key) {
        var self  =this;
        var viewConf = self._viewConfig[key];
        var checked = viewConf.view.getChecked();
        if (checked.length === 0)
            return ;
        $.confirmDialog('Sei sicuro di voler cancellare gli elementi selezionati?').ok(function () {
            var urlValues = {
                model:viewConf.params.modelName,
            };
            var sConf = {
                url : Routes.getUrlInstance('removeAll',urlValues),
                query_params : {},
                method : Routes.remove.method,
                post_params : {'ids': checked}
            };
            $.waitStart();
            self._executeRequest(sConf,function (json) {
                $.waitEnd();
                if (json.error) {
                    $.errorDialog(json.msg);
                    return;
                }
                viewConf.view.renderWait();
                viewConf.view.setData(null);
                self.renderView(key);
            });
        });
    },

    actionBack : function () {
        window.history.back();
    },


    /**
    * esegue una richiesta ajax manuale tra quelle definite nell'oggetto Route
    * @param routeType : tipo di route da usare
    * @param routeParams : vettore associativo dei parametri per istanziare la route
    * @param params : opzionale, vettore associativo per i parametri in get e in post 
    * @param callback : eventuale callaback a cui dare il risultato
    */
    execute : function (routeType,routeParams,params,callback) {
        var self = this;

        var sConf = {
            url : Routes.getUrlInstance(routeType,routeParams),
            query_params : (params && params.query_params)?params.query_params:{},
            method : Routes[routeType].method,
            post_params : (params && params.post_params)?params.post_params:{}
        };
        var cb = callback?callback:function () {};
        $.waitStart();
        self._executeRequest(sConf,function (json) {
            $.waitEnd();
            cb(json);
        });


        // var url = Routes.getUrlInstance(routeType,routeParams);
        // var qParams = (params && params.query_params)?'?'+jQuery.param( confRequest.params ):'';
        // var pParams = (params && params.post_params)?params.post_params:{};
        // var cb = callback?callback:function () {};
        // log.debug('execute',url,qParams,pParams);
        // Routes[routeType].method(url+qParams,pParams,function (json) {
        //     return cb(json);
        // }).fail(function (f) {
        //     var tmpJson = {error : 1, msg : $.getFailMessage(f)};
        //     return cb(tmpJson);
        // });
    },
    waitQueueJob : function (jobId,callback) {
        var self = this;
        self.execute('queueStatus',{jobId:jobId},{},function (json) {
            if (json.error) {
                if (callback) {
                    callback(json);
                } else {
                    $.errorDialog(json.msg);
                }
                return ;
            }
            if (json.job.end) {
                if (callback) {
                    callback(json);
                } else {
                    if (json.job.error) {
                        $.errorDialog(json.job.msg);
                    }
                }
                return ;
            }

            setTimeout(function (jobId) {
                self.waitQueueJob(jobId,callback);
            },2000);
        })
    }
});